(() => {
  'use strict';
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('sv').trim();
  function initCatalog(root) {
    if (root.dataset.stReady) return;
    const grid = root.querySelector('[data-st-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-st-item]'));
    const artist = root.querySelector('[data-st-artist-filter]');
    const search = root.querySelector('[data-st-search]');
    const sort = root.querySelector('[data-st-sort]');
    const more = root.querySelector('[data-st-more]');
    const count = root.querySelector('[data-st-count]');
    const empty = root.querySelector('[data-st-empty]');
    const allButton = root.querySelector('.st-catalog__all');
    if (!cards.length || !artist || !search || !sort || !more || !count || !empty) return;
    root.dataset.stReady = 'true';
    const initial = Number(root.dataset.stInitial) || 8;
    let limit = initial;
    const viewButtons = [...root.querySelectorAll('[data-st-view-button]')];
    const setView = view => {
      root.dataset.stView = view;
      viewButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.stViewButton === view)));
    };
    viewButtons.forEach(button => button.addEventListener('click', () => setView(button.dataset.stViewButton)));
    setView(root.dataset.stView || 'gallery');
    const records = cards.map(card => ({ card, artist: card.dataset.stArtist || '', title: card.dataset.stTitle || '', price: Number(card.dataset.stPrice) || 0, order: Number(card.dataset.stOrder) || 0, search: normalize(`${card.dataset.stTitle || ''} ${card.dataset.stArtist || ''}`) }));
    const artists = Array.from(new Set(records.map(record => record.artist).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'sv'));
    artists.forEach(name => { const option = document.createElement('option'); option.value = name; option.textContent = name; artist.append(option); });
    artist.closest('label').hidden = artists.length === 0;
    root.querySelectorAll('[data-st-controls]').forEach(control => { control.hidden = false; });
    function update({ focusNew = false } = {}) {
      const query = normalize(search.value);
      const queryWords = query.split(/\s+/).filter(Boolean);
      const results = records.filter(record => (!artist.value || record.artist === artist.value) && queryWords.every(word => record.search.includes(word)));
      results.sort((a, b) => sort.value === 'price-low' ? a.price - b.price || a.order - b.order : sort.value === 'price-high' ? b.price - a.price || a.order - b.order : sort.value === 'name' ? a.title.localeCompare(b.title, 'sv') : a.order - b.order);
      const previouslyVisible = new Set(records.filter(record => !record.card.hidden).map(record => record.card));
      records.forEach(record => { record.card.hidden = true; record.card.classList.remove('is-gallery-feature'); });
      const fragment = document.createDocumentFragment();
      results.forEach((record, index) => { record.card.hidden = index >= limit; record.card.classList.toggle('is-gallery-feature', index === 0); fragment.append(record.card); });
      grid.append(fragment);
      const visibleCount = Math.min(limit, results.length);
      count.textContent = results.length === 0 ? 'Inga motiv matchar din sökning' : `Visar ${visibleCount} av ${results.length} motiv`;
      more.hidden = results.length <= limit;
      empty.hidden = results.length > 0;
      if (allButton) allButton.classList.toggle('is-active', !artist.value && !query);
      if (focusNew) {
        const next = results.find(record => !record.card.hidden && !previouslyVisible.has(record.card));
        next?.card.querySelector('a')?.focus({ preventScroll: true });
      }
    }
    function filter() { limit = initial; update(); }
    search.addEventListener('input', filter);
    artist.addEventListener('change', filter);
    sort.addEventListener('change', update);
    root.querySelectorAll('[data-st-reset]').forEach(button => button.addEventListener('click', () => { search.value = ''; artist.value = ''; sort.value = 'featured'; limit = initial; update(); }));
    more.addEventListener('click', () => { limit += initial; update({ focusNew: true }); });
    const allowTilt = window.matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
    cards.forEach(card => {
      const visual = card.querySelector('.st-card__visual');
      if (!visual) return;
      let frame = 0;
      visual.addEventListener('pointermove', event => {
        if (!allowTilt.matches) return;
        const bounds = visual.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - .5;
        const y = (event.clientY - bounds.top) / bounds.height - .5;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          visual.style.setProperty('--card-rx', `${-y * 5}deg`);
          visual.style.setProperty('--card-ry', `${x * 5}deg`);
          visual.style.setProperty('--card-light', `${50 + x * 40}%`);
        });
      });
      visual.addEventListener('pointerleave', () => {
        cancelAnimationFrame(frame);
        visual.style.removeProperty('--card-rx');
        visual.style.removeProperty('--card-ry');
        visual.style.removeProperty('--card-light');
      });
    });
    update();
  }
  function init(scope = document) {
    if (scope.matches?.('[data-st-catalog]')) initCatalog(scope);
    scope.querySelectorAll?.('[data-st-catalog]').forEach(initCatalog);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
